/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 **/
import { View } from '@az/starc-ui'
import { createHashRouter, Outlet, RouterProvider } from 'react-router-dom'

import Header from './Header/Header'
import LandingPage from './LandingPage'
import StoreDetailsPage from './StoreDetailsPage'

import './Layout.css'

function Base() {
  return (
    <>
      <Header />
      <View direction="row" attributes={{ style: { backgroundColor: 'transparent' } }}>
        <View.Item columns={12}>
          <View gap={4} direction="row" className="body-wrapper">
            <View.Item columns={12}>
              <Outlet />
            </View.Item>
          </View>
        </View.Item>
      </View>
    </>
  )
}

const router = createHashRouter([
  {
    element: <Base />,
    children: [
      {
        path: '/',
        element: <LandingPage />
      },
      {
        path: '/storedetails/:storeNumber',
        element: <StoreDetailsPage />
      }
    ]
  }
])

function LayoutPage() {
  return <RouterProvider router={router} />
}

export default LayoutPage
